import { useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import { Button, Popover, Tag } from 'antd'
import { useTRPC } from '@/trpc/react.ts'
import { CONTRACT_DOCUMENT_STATUS } from './const/contract-labels.ts'

export function OrderContractCountCell({
  order,
  onOpen
}: {
  order: { type: 'rental' | 'service'; id: number; orderNo: string; contractDocumentCount: number }
  onOpen: () => void
}) {
  const trpc = useTRPC()
  const [hovering, setHovering] = useState(false)
  const query = useQuery({
    ...trpc.order.contracts.summary.queryOptions({ orderType: order.type, orderId: order.id }),
    enabled: hovering && order.contractDocumentCount > 0
  })
  const content = query.isError ? (
    <Button size="small" onClick={() => void query.refetch()}>
      加载失败，重试
    </Button>
  ) : query.isLoading ? (
    '正在加载合同…'
  ) : (
    <div className="max-h-80 max-w-96 space-y-2 overflow-y-auto">
      {query.data?.map((document) => (
        <div key={document.id} className="flex items-start justify-between gap-4">
          <span>{document.title}</span>
          <Tag className="shrink-0" color={CONTRACT_DOCUMENT_STATUS[document.status].color}>
            {CONTRACT_DOCUMENT_STATUS[document.status].label}
          </Tag>
        </div>
      ))}
    </div>
  )
  return order.contractDocumentCount ? (
    <Popover content={content} title="合同文件" trigger={['hover', 'focus']} onOpenChange={setHovering}>
      <Button
        size="small"
        type="link"
        className="px-0!"
        onClick={onOpen}
        aria-label={`查看订单 ${order.orderNo} 的 ${order.contractDocumentCount} 份合同`}
      >
        {order.contractDocumentCount} 份
      </Button>
    </Popover>
  ) : (
    <Button
      size="small"
      type="link"
      className="px-0!"
      onClick={onOpen}
      aria-label={`查看订单 ${order.orderNo} 的合同文件`}
    >
      0 份
    </Button>
  )
}
